import React from 'react';
import { bool, string } from 'prop-types';
import { CATEGORY } from '../../constants';

const DualPath = ({ twoTileToggle, category }) => {

  const howToGetIt = () => {
    if ([CATEGORY.PLUMBING_REPAIR, CATEGORY.WATER_HEATER_REPAIR]
      .includes(category)) {
      return (
        <span className="fulfillment__unavailable--content--dual-path">
          You have selected expert in-home repair,
          so this item isn&#39;t available to add to your cart for pickup or delivery.
          One of our Pros will reach out to discuss professional repair service and pricing.
        </span>
      );
    }
    return (
      <span className="fulfillment__unavailable--content--dual-path">
        You have selected expert in-home installation,
        so this item isn&#39;t available to add to your cart for pickup or delivery.
        One of our Pros will reach out to discuss product, professional installation and pricing.
      </span>
    );
  };

  return twoTileToggle ? (
    <div className="fulfillment__unavailable">
      {howToGetIt()}
    </div>
  ) : (
    <div className="fulfillment__unavailable">
      <fieldset className="fulfillment__unavailable--fieldset">
        <legend className="fulfillment__unavailable--title">How To Get it</legend>
        {howToGetIt()}
      </fieldset>
    </div>
  );
};

DualPath.propTypes = {
  twoTileToggle: bool,
  category: string
};

DualPath.defaultProps = {
  twoTileToggle: false,
  category: ''
};

export { DualPath };
